
(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentAddMultipleController', [
            '$scope', 'config', '$state', 'errorsExtend', 'documentService', 'documentTypeService', 'authExtend', 'storageService', 'fileService', 'twainCapture',
            function documentAddMultipleController($scope, config, $state, errors, documentService, documentTypeService, authExtend, storageService, fileService, twainCapture) {

                $scope.enableMassiveDigitalization = authExtend.isInRole('DOCUMENT MASSIVE DIGITALIZATION');
                $scope.canDigitalize = authExtend.isInRole('DOCUMENT DIGITALIZATION');
                $scope.showGoBackSearch = false;
                $scope.docContainersPlaceHolder = 'DocumentDocumentContainerPlaceholder';
                $scope.document = {
                    DocumentTypes: [],
                    organizationalUnitId: authExtend.getOrganizationId(),
                    isDocumentPerFile: true,
                    deferredMetadataValidation: true
                };

                $scope.aux = {
                    files: [],
                    filesTemp: []
                };

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.optionsDocumentTypes = [];

                documentTypeService.getFunctionsTypes(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });

                    if ($scope.optionsDocumentTypes.length === 1) {
                        $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                        $scope.aux.selectedDocumentTypeid = $scope.optionsDocumentTypes[0].id;
                    }

                }, function (error) {
                    errors.showError(error);
                    $state.go('document-find');
                });

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'simple').then(function (result) {
                        var documentDocType = {
                            documentTypeName: result.name,
                            documentTypeId: result.id
                        };

                        $scope.document.DocumentTypes = [];
                        $scope.document.DocumentTypes.push(documentDocType);

                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.cancel = function () {
                    $state.go('document-find');
                };

                $scope.save = function () {
                    var msj = '';
                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        msj = 'VerifyFormData';
                    }

                    if ($scope.aux.files.length <= 0) {
                        msj += 'VerifyFormFile';
                    }

                    if (msj !== '') {
                        errors.showError(msj);
                        return;
                    }
                    return documentService.create($scope.document, $scope.aux.files).then(function (document) {
                        var filter = storageService.getMyDocumentFilter();
                        filter.name = '';

                        storageService.setMyDocumentFilter(filter);
                        $state.go('document-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.initDocumentFind = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    }
                };

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file);
                            if (~index) {
                                $scope.aux.files[index] = file;
                            } else {
                                $scope.aux.files.push(file);
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.previewFile = function (item, index) {

                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                };

                $scope.hidePreview = function () {

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.beginDigitalization = function () {
                    $scope.digitalizerOpen = true;
                };

                $scope.cancelDigitalization = function () {
                    $scope.digitalizerOpen = false;
                };

                $scope.scanning = false;
                $scope.hasScannedDocument = false;

                $scope.digitalize = function () {

                    $scope.scanning = true;

                    var callback = function () {
                        twainCapture.scanOne()
                            .then(function (index) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            }, function (error) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                                errors.showError(error);
                            });
                    };

                    twainCapture.deleteFirstImage().then(callback, callback);
                };

                $scope.addDigitalized = function () {
                    twainCapture.popImageFile()
                        .then(function (file) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            $scope.aux.filesTemp.push(file);
                            $scope.addFile();
                        }, function (error) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            errors.showError(error);
                        });
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });
            }
        ]);
})();